module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/LXL3yJhvIkU4qKumciu8M-f7fd7f927d426bd91ec67d989c537987.jpg";